import React, { memo } from 'react';
import { LeftTopContent, SourceIconContainer, PriorityIndicator } from '../styles';
import { renderSourceIcon } from '../../../helpers/renderSourceIcon';
import { getPriority } from '../utils';

export const LeadHeader = memo(({ item }) => {
  const priority = getPriority(item);
  const sourceIcon = renderSourceIcon(item && item.source);

  return (
    <>
      <LeftTopContent>
        {sourceIcon && (
          <SourceIconContainer>
            {sourceIcon}
          </SourceIconContainer>
        )}
      </LeftTopContent>
      <PriorityIndicator priority={priority} />
    </>
  );
});

LeadHeader.displayName = 'LeadHeader';